import React from 'react'
import './style.scss'
import { Routes, Route } from 'react-router-dom'
import Index from './Index'
import FourOFour from '../FourOfour/Index'

const Master = () => {
    return (
        <div className="timeline-master">
                        <Routes>
                                <Route path="/" element={<Index />} />

                <Route path="*" element={<FourOFour />} />
            </Routes>
        </div>
    );
};

export default Master;